import React, { useState, useEffect } from 'react';
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

const technicalProjects = [
    {
        id: 1,
        title: "Instalación y Montaje",
        images: [
            "/img/proyectos-realizados/IMG-20251218-WA0113.webp",
            "/img/proyectos-realizados/IMG-20251218-WA0172.webp",
            '/img/proyectos-realizados/InstalacionMontaje/img1.webp',
            '/img/proyectos-realizados/InstalacionMontaje/img2.webp',
        ]
    },
    {
        id: 2,
        title: "Mantenimiento Preventivo",
        images: [
            "/img/proyectos-realizados/IMG-20251219-WA0059.webp",
            "/img/proyectos-realizados/IMG-20251219-WA0070.webp"
        ]
    },
    {
        id: 3,
        title: "Diagnóstico Eléctrico",
        images: [
            "/img/proyectos-realizados/IMG-20251218-WA0065.webp",
            "/img/proyectos-realizados/IMG-20251218-WA0151.webp",
            "/img/proyectos-realizados/IMG-20251219-WA0063.webp",
            "/img/proyectos-realizados/DiagnosticoElectrico/img1.webp",
            "/img/proyectos-realizados/DiagnosticoElectrico/img2.webp",
            "/img/proyectos-realizados/DiagnosticoElectrico/img3.webp",
        ]
    },
    {
        id: 4,
        title: "Soporte Técnico",
        images: [
            "/img/proyectos-realizados/IMG-20251218-WA0102.webp",
            "/img/proyectos-realizados/SoporteTecnico/img1.webp",
            "/img/proyectos-realizados/SoporteTecnico/img2.webp",
            "/img/proyectos-realizados/SoporteTecnico/img3.webp",
            "/img/proyectos-realizados/SoporteTecnico/img4.webp",
        ]
    },
];

const brandPresence = [
    {
        id: 1,
        title: "",
        images: [
            "/img/proyectos-realizados/PortafolioEvidencias/TC1.webp",
            "/img/proyectos-realizados/PortafolioEvidencias/TC2.webp",
            "/img/proyectos-realizados/PortafolioEvidencias/TC3.webp",
            "/img/proyectos-realizados/PortafolioEvidencias/TC4.webp",
            "/img/proyectos-realizados/PortafolioEvidencias/img1.webp",
            "/img/proyectos-realizados/PortafolioEvidencias/img2.webp",

            //
            "/img/proyectos-realizados/PortafolioEvidencias/LaFerre.webp",
            "/img/proyectos-realizados/PortafolioEvidencias/Neto1.webp",
            "/img/proyectos-realizados/PortafolioEvidencias/Neto2.webp",
            "/img/proyectos-realizados/PortafolioEvidencias/Neto3.webp",
            "/img/proyectos-realizados/PortafolioEvidencias/Neto4.webp",
            "/img/proyectos-realizados/PortafolioEvidencias/Neto5.webp",
            "/img/proyectos-realizados/PortafolioEvidencias/Neto6.webp",
            "/img/proyectos-realizados/PortafolioEvidencias/FedEx.webp",
            "/img/proyectos-realizados/PortafolioEvidencias/Restaurante1.webp",
            "/img/proyectos-realizados/PortafolioEvidencias/Restaurante2.webp",
            "/img/proyectos-realizados/PortafolioEvidencias/Restaurante3.webp",

        ]
    }
];

const ProjectCarousel = ({ images, title, onClick }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % images.length);
        }, 10000);
        return () => clearInterval(timer);
    }, [images.length]);

    return (
        <div className="relative w-full h-full cursor-pointer group" onClick={() => onClick(currentIndex)}>
            {images.map((img, i) => (
                <img
                    key={i}
                    src={img}
                    alt={`${title} - ${i}`}
                    // RENDIMIENTO: Solo carga las imágenes cuando están cerca de la pantalla
                    loading="lazy"
                    className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-[2000ms] ${
                        i === currentIndex ? "opacity-100" : "opacity-0"
                    }`}
                />
            ))}

            <div className="absolute inset-0 bg-black/30 group-hover:bg-black/50 transition-opacity flex items-center justify-center">
                <span className="text-white font-bold text-lg text-center px-4 drop-shadow-md uppercase tracking-wide">
                    {title}
                </span>
            </div>

            <div className="absolute bottom-4 right-4 bg-black/60 backdrop-blur-sm text-white text-[10px] font-black px-3 py-1.5 rounded-full border border-white/20 shadow-xl z-20">
                {currentIndex + 1} / {images.length}
            </div>

            <div className="absolute bottom-0 left-0 h-1 bg-ctex-orange transition-all duration-[10000ms] ease-linear"
                 style={{ width: `${((currentIndex + 1) / images.length) * 100}%` }} />
        </div>
    );
};

const WorkGallery = () => {
    const [open, setOpen] = useState(false);
    const [slides, setSlides] = useState([]);
    const [index, setIndex] = useState(0);

    const handleOpenGallery = (project, imgIndex) => {
        setSlides(project.images.map(src => ({ src })));
        setIndex(imgIndex);
        setOpen(true);
    };

    return (
        <section className="py-24 bg-gray-50">
            <div className="container mx-auto px-4">
                <div className="text-center mb-16">
                    <h2 className="text-4xl font-extrabold text-ctex-blue mb-4 tracking-tight uppercase italic">
                        Evidencia de Trabajos Realizados
                    </h2>
                    <p className="text-gray-500 max-w-2xl mx-auto font-medium">
                        Documentación técnica de instalaciones, diagnósticos y mantenimientos ejecutados por nuestro personal experto.
                    </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-24">
                    {technicalProjects.map((project) => (
                        <div key={project.id} className="group relative overflow-hidden rounded-3xl shadow-lg h-80 border border-gray-200 bg-white transform transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl">
                            <ProjectCarousel images={project.images} title={project.title} onClick={(imgIndex) => handleOpenGallery(project, imgIndex)} />
                        </div>
                    ))}
                </div>

                <div className="bg-ctex-blue rounded-[3rem] p-12 text-white overflow-hidden relative shadow-2xl">
                    <div className="relative z-10 grid lg:grid-cols-2 gap-12 items-center">
                        <div>
                            <h2 className="text-3xl font-bold mb-6 uppercase tracking-tighter text-ctex-orange italic">Nuestro Trabajo</h2>
                            <p className="text-blue-50 text-xl mb-8 leading-relaxed font-medium">
                                “Empresas de distintos sectores han confiado en nuestro trabajo para resolver, optimizar y mantener sus sistemas técnicos en operación.”
                            </p>
                            <div className="flex gap-4">
                                <div className="bg-white/10 backdrop-blur-md px-6 py-3 rounded-2xl border border-white/10">
                                    <p className="text-sm uppercase text-blue-200 font-bold tracking-widest">Garantía de Continuidad</p>
                                </div>
                            </div>
                        </div>

                        <div className="grid grid-cols-1 gap-4">
                            {brandPresence.map((project) => (
                                <div key={project.id} className="group relative overflow-hidden rounded-3xl shadow-2xl h-80 border-4 border-white/20">
                                    <ProjectCarousel images={project.images} title={project.title} onClick={(imgIndex) => handleOpenGallery(project, imgIndex)} />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="mt-16 text-center">
                    <p className="text-xs text-gray-400 font-bold uppercase tracking-widest">
                        * Imágenes reales protegidas por la identidad de marca CTEX.
                    </p>
                </div>
            </div>

            {/* Lightbox con optimización de renders */}
            <Lightbox
                open={open}
                close={() => setOpen(false)}
                index={index}
                slides={slides}
                on={{ view: ({ index }) => setIndex(index) }}
                render={{
                    controls: () => (
                        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-[300]">
                            <div className="bg-ctex-orange text-white text-[10px] font-black px-4 py-1.5 rounded-full uppercase tracking-[0.2em] shadow-2xl border border-white/20">
                                Imagen {index + 1} de {slides.length}
                            </div>
                        </div>
                    ),
                }}
            />
        </section>
    );
};

export default WorkGallery